import React from 'react';
import CloseIcon from '@elliemae/ds-icons/Close';
import DSButton from '@elliemae/ds-basic/Button';
import { ModalHeader, ModalHeaderTopRight } from '../blocks.js';
import { Title } from './Title.js';
import '@babel/runtime/helpers/esm/defineProperty';
import '@elliemae/ds-classnames';

/* eslint-disable max-lines */
var FormHeader = function FormHeader(_ref) {
  var showClose = _ref.showClose,
      modalTitle = _ref.modalTitle,
      modalType = _ref.modalType,
      onClose = _ref.onClose;
  return /*#__PURE__*/React.createElement(ModalHeader, {
    classProps: {
      type: 'selection'
    }
  }, /*#__PURE__*/React.createElement(Title, {
    modalTitle: modalTitle,
    modalType: modalType
  }), /*#__PURE__*/React.createElement(ModalHeaderTopRight, {
    classProps: {
      type: 'form'
    }
  }, showClose && /*#__PURE__*/React.createElement(DSButton, {
    buttonType: "link",
    containerProps: {
      'data-testid': 'modal-close-btn'
    },
    icon: /*#__PURE__*/React.createElement(CloseIcon, null),
    onClick: onClose
  })));
};

export default FormHeader;
export { FormHeader };
//# sourceMappingURL=FormHeader.js.map
